<template>
  <section id="draw" class="min-h-scresen w-full lg:flex bg-gray-100">
    <div class="w-full lg:w-1/2 align-middle leading-6 mb-6 p-4 md:p-10" id="instructions">
      <h2
        class="text-4xl my-4 lg:mt-0 md:text-6xl leading-tight md:max-w-xl mb-8 "
      >
        Draw a heart
      </h2>
      <p>
        From a simple doodle to a masterpiece, show us your love!<br>
        Click in the white space to start drawing.
      </p>





<div id="msg" class="warning p-3 bg-pink-100 text-red-100 mb-4" v-if="ie11" ><p>This feature is not supported by your browser. Please update your browser for the best experience</p></div>



      <div class="text-md lg:max-w-md" v-show="showInstructions">
        <p>
          <strong>Color</strong><br />

          Add colours to your palette with the <span class="plus inline-flex justify-center items-center  w-6 h-6 mx-1 rounded-full border-dashed border border-red-100 text-red-100" >+</span>&nbsp; button.<br>
          After you add a new colour, you can load it into your brush by clicking once on its swatch <span class="plus inline-flex justify-center items-center  w-5 h-5 mx-1 rounded-full bg-red-100"  >+</span><br>Double click to change the color.
        </p>
        <p>
          <strong>Brush</strong><br />
          Change the thickness of the line as you like, using the 

      <span class="" ></span>
      <span
        class="w-6 h-6 rounded-full inline-flex items-center justify-center m2 border border-red-100 border-solid"
      >
        <span
          class="sizeIndicator w-3 h-3 inline-block rounded-full   bg-red-100 "        
        >
        </span>
      </span>

  
          
          tool in the bottom right.
        </p>

        <p>
          <strong>Submit</strong><br />
          When it’s complete, click submit, and sign your work. <br>Once your love
          is ready to share with the world, we'll send you a link.
        </p>
      </div>
      <div id="instructions-switch pb-4 mb-8" class="">
        <a @click="toggleInstructions">
          {{ showInstructions ? "Hide" : "Show" }} Instructions
          <i
            class="{'fa fa-chevron-down':showInstructions,'fa fa-chevron-up':!showInstructions}"
          ></i>
        </a>
      </div>
    </div>

    <div class="lg:w-1/2 relative flex flex-col" id="drawcolumn" :class="{appMode:isTouch&&canvasInitiated}" v-in-viewport>


    <div id="drawingapp" class="drawingapp md:relative" >
      <div id="topbar" class="border-b border-b-gray-100 h-10 w-full" v-show="isTouch&&canvasInitiated&&canShowApp"></div>
      <div id="surface" class="relative w-full"></div>
     <transition name="fade"> 
        <button
          id="undo"
          @click="canvasUndo()"
          class="uibtn rounded-full px-2 "
          v-show="showUi&&canvasInitiated"
        >
          Undo
        </button>
         </transition>

<transition name="fade">
        <button
          id="clear"
          @click="canvasReset()"
          class="uibtn rounded-full px-2 "
          v-show="showUi&&canvasInitiated&&!isTouch"
        >
          Clear
        </button>
     </transition>
     <transition name="fade">
        <button
          id="cancel"
          @click="cancelDrawing"
          class="uibtn rounded-full px-2 "
          v-show="showUi&&canvasInitiated&&isTouch"
        >
          Cancel
        </button>
     </transition>
            <!-- <transition name="fade">
        <button
          id="redo"
          @click="canvasRedo()"
          class="uibtn rounded-full px-2"
          v-show="showUi"
        >
          Redo
        </button>
      </transition> -->
      <transition name="fade">
        <div
          id="drawaheartoverlay"
          class="absolute top-0 left-0 lg:pb-16 flex flex-col w-full h-full justify-center items-center z-50"
          v-if="!canvasInitiated"
          @mousedown="canvasInitiated = true"
          @touchstart="canvasInitiated = isTouch = true"
        >
          <svg
            id="heart"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 230 230"
          >
            <path
              class="heartpath"
              d="M117.31,54.73c.21-.29,0-.28.32-.66.11-.17.32-.32.48-.54s.18-.44.32-.65.3-.37.44-.58.3-.36.44-.57.17-.46.3-.67.32-.36.45-.57.23-.43.36-.63.37-.34.49-.55.16-.46.29-.67.24-.41.37-.61.28-.39.4-.6.19-.45.31-.66.36-.35.48-.56.16-.47.28-.68.27-.4.39-.61.2-.45.31-.66.31-.39.41-.61.18-.45.29-.67.17-.46.27-.67.11-.49.2-.7.36-.38.45-.6.11-.48.19-.7"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M132.73,29.66c.24-.27.07-.28.38-.62.13-.15.32-.3.5-.5s.26-.39.44-.57.44-.21.62-.39.26-.4.43-.57.39-.28.56-.46l.52-.49c.16-.16.25-.41.43-.58s.4-.27.57-.43.28-.4.46-.56.37-.3.55-.46.38-.27.56-.43.27-.4.45-.56.4-.26.58-.42.33-.34.51-.5.45-.2.63-.36.29-.39.48-.54l.55-.46c.18-.15.39-.27.58-.41s.33-.35.52-.5.46-.18.65-.33.32-.36.51-.5.41-.25.61-.39.36-.31.56-.44.44-.21.64-.34.37-.31.57-.44.37-.31.57-.44"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M164.8,9.8c.36,0,.37.11.73.1s.36-.14.72-.15.36.17.73.17.36-.12.72-.13.36,0,.73,0,.36,0,.72,0,.37.17.73.16.36-.19.72-.2.36,0,.72,0,.36-.11.72-.12.36.24.73.23.36-.13.72-.13.36.09.73.09h.72c.36,0,.36-.17.72-.18s.37.12.73.11.36-.14.73-.14.36,0,.72,0,.37.07.73.06.36-.16.73-.17.36.09.73.08.36-.06.72-.06.37.17.73.16.37-.16.73-.16l.73,0c.37,0,.37,0,.74,0s.36-.09.73-.1"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M203.89,14.64c.31.19.16.24.54.49.18.11.37.25.6.4s.37.27.59.41.45.17.66.31.36.31.57.45.43.21.63.35.35.33.55.48.44.21.63.35.32.37.51.51.42.24.62.39.39.27.58.42.36.32.55.47.3.39.49.54.44.23.62.38.35.34.53.5.41.27.58.43.26.44.43.61.4.29.56.46.29.39.45.57.32.37.47.55.39.31.53.5a5.58,5.58,0,0,1,.35.63"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M223.71,41.81c.13.33.15.21.31.63.07.19.07.44.17.69s.13.43.22.67.16.42.24.65.29.39.38.62l.23.66c.08.22,0,.49.08.72s.14.44.22.67.12.45.2.67.28.4.35.62.08.47.15.69.24.42.31.64.05.48.12.7.24.42.31.64,0,.49.06.72.21.43.28.66.15.44.21.67.09.47.14.7,0,.49.05.72.25.42.31.65.07.47.12.7.19.45.23.68-.09.49-.05.72"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M226.72,73.85c-.11.34-.13.23-.27.67-.07.2,0,.47-.1.74s-.26.4-.35.65-.11.46-.19.71-.09.47-.17.71-.17.45-.25.69-.1.47-.18.71-.23.43-.31.67-.18.44-.26.68-.15.45-.23.69,0,.5-.1.73l-.24.7c-.08.23-.31.41-.39.64l-.25.69c-.09.23-.19.46-.27.68s0,.51-.11.74-.23.44-.31.67-.07.5-.16.72-.25.44-.33.66-.07.51-.15.73-.31.42-.39.63-.11.51-.19.71"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M213.42,106.77c-.21.29-.15.34-.35.63s-.19.3-.4.6-.23.27-.44.56-.26.25-.47.54-.29.24-.49.53-.19.3-.4.6-.06.39-.27.68-.35.19-.56.48-.25.27-.45.56-.08.38-.28.67-.32.21-.52.5-.17.32-.37.61-.15.34-.36.63-.22.28-.43.57-.15.33-.36.63-.28.24-.49.53-.23.28-.43.57l-.41.58c-.21.3-.08.39-.29.69l-.41.58c-.21.3-.35.2-.56.49s-.22.29-.43.58-.22.28-.43.57-.08.38-.29.68-.26.25-.47.54-.12.36-.33.66-.29.24-.5.53-.11.37-.32.66-.33.21-.54.51"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M190.59,140.38c-.24.28-.22.16-.51.51-.13.16-.31.33-.48.55s-.28.37-.45.57-.32.35-.48.55-.27.39-.43.59-.26.4-.42.59-.36.32-.52.52-.26.4-.42.59-.29.38-.45.57-.32.35-.48.54-.35.34-.5.52-.37.33-.53.52l-.45.57c-.16.19-.21.47-.36.66s-.42.29-.57.48-.34.35-.49.54-.22.45-.37.64-.39.31-.54.5-.28.41-.43.6-.27.42-.41.6l-.47.56c-.16.21-.26.43-.4.61s-.37.35-.5.53"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M168.35,166.22c-.27.23-.13.24-.47.54l-.53.48c-.16.14-.37.26-.56.43s-.33.32-.51.5-.28.38-.46.55-.36.3-.53.47-.31.36-.48.53-.37.29-.54.47-.35.32-.51.5-.3.36-.47.54-.33.33-.5.51-.27.38-.43.56-.27.38-.43.56-.36.31-.52.49-.26.4-.41.58-.29.38-.44.56-.33.35-.48.54-.34.33-.49.52-.36.32-.5.51l-.42.58c-.14.19-.17.47-.31.66s-.4.3-.54.49-.31.36-.45.56-.16.47-.3.67-.36.33-.49.53-.23.42-.36.63"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M149.84,191.07c-.18.3-.09.24-.33.62-.1.17-.28.34-.42.56s-.27.37-.41.58-.2.42-.33.63-.33.33-.47.54-.16.45-.29.65-.34.34-.47.54-.18.44-.31.64-.26.39-.4.58-.32.35-.45.54-.26.39-.4.58-.2.43-.34.62-.3.36-.44.56-.25.4-.39.59-.33.34-.47.53-.3.36-.45.55-.26.4-.4.59-.31.36-.46.54-.25.41-.4.59-.25.41-.4.59-.36.32-.51.5-.26.41-.41.58-.3.38-.46.55-.34.33-.5.5-.36.31-.52.47"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M132.09,213.71c-.22.29-.2.3-.43.59s-.36.18-.59.47-.23.28-.46.56-.16.34-.39.63-.17.34-.39.63-.33.21-.55.5-.31.23-.54.52-.08.4-.3.69-.29.25-.51.54-.26.26-.49.55-.31.22-.54.51-.11.39-.34.68-.17.33-.4.62-.29.24-.52.53-.26.26-.49.55-.16.34-.39.63-.33.21-.56.5-.1.4-.33.69a1.45,1.45,0,0,1-.55.49c-.3.19-.21,0-.58-.3l-.59-.42c-.18-.13-.32-.36-.53-.51l-.6-.43c-.19-.13-.46-.18-.66-.33s-.35-.33-.55-.48-.41-.26-.61-.41-.32-.37-.52-.52-.36-.32-.55-.47-.41-.26-.61-.41-.35-.33-.54-.49-.43-.24-.62-.4-.44-.24-.63-.4-.31-.4-.49-.55-.44-.25-.62-.41-.39-.31-.57-.47-.34-.36-.52-.52-.3-.41-.47-.57-.27-.44-.43-.61-.36-.34-.52-.51-.5-.23-.65-.41-.13-.54-.25-.72a2.09,2.09,0,0,1-.24-.65"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M99.35,203.08c-.17-.3,0-.31-.23-.67-.11-.16-.34-.28-.49-.49s-.24-.37-.39-.56-.36-.28-.51-.46-.29-.35-.45-.52l-.5-.47c-.16-.16-.32-.33-.49-.48s-.35-.28-.54-.42-.29-.37-.49-.5-.38-.26-.58-.37-.42-.18-.64-.32-.41-.22-.61-.37-.32-.35-.52-.5-.32-.35-.5-.5-.45-.2-.64-.36-.32-.34-.51-.49-.33-.34-.52-.49-.3-.37-.48-.53-.42-.24-.6-.4-.39-.29-.56-.45-.32-.37-.49-.53-.33-.35-.5-.51-.4-.29-.57-.45-.28-.4-.45-.56-.43-.25-.6-.41-.28-.41-.45-.56-.43-.27-.58-.43l-.51-.49c-.32-.32-.2-.3-.45-.55"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M73.16,181.22c-.28-.23-.13-.26-.48-.55-.16-.13-.33-.31-.54-.49s-.41-.23-.61-.4-.39-.26-.58-.43-.25-.43-.44-.6l-.54-.48c-.17-.16-.44-.22-.63-.38s-.37-.3-.55-.47-.25-.44-.43-.6-.43-.25-.61-.41-.34-.35-.51-.52-.42-.26-.6-.43-.34-.34-.52-.5l-.53-.5c-.18-.17-.34-.35-.51-.52l-.53-.51c-.17-.18-.26-.43-.43-.6l-.49-.54c-.17-.18-.38-.32-.54-.5s-.37-.33-.53-.51-.26-.42-.41-.6-.27-.42-.42-.6-.4-.31-.55-.5-.26-.42-.39-.61-.27-.42-.39-.62-.2-.45-.31-.65-.32-.4-.41-.6"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M49,154.05c-.26-.25-.2-.32-.45-.57s-.32-.19-.57-.44-.24-.27-.5-.52-.21-.3-.47-.55l-.51-.51c-.26-.26-.3-.21-.56-.47s-.2-.31-.45-.56-.25-.27-.5-.52-.31-.21-.57-.47-.28-.22-.54-.48-.18-.33-.44-.59l-.51-.51c-.25-.25-.32-.18-.58-.44s-.27-.24-.52-.49-.18-.34-.44-.6-.32-.19-.58-.45-.24-.27-.5-.53-.31-.2-.57-.46l-.52-.52c-.26-.25-.27-.24-.53-.5"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M30.19,133.17c-.29-.23-.32,0-.67-.34-.16-.13-.32-.33-.53-.51s-.28-.4-.48-.57-.38-.28-.57-.45-.43-.25-.62-.42-.25-.43-.43-.6-.47-.21-.65-.39-.26-.43-.43-.6-.43-.27-.6-.45-.31-.39-.47-.57-.26-.42-.41-.61-.31-.39-.45-.57-.34-.34-.48-.55-.18-.46-.32-.68-.24-.41-.37-.62-.34-.36-.48-.57-.3-.38-.43-.59-.13-.5-.25-.71l-.38-.63c-.13-.22-.37-.36-.5-.56s-.27-.42-.4-.62-.12-.51-.24-.71-.36-.39-.47-.58-.24-.47-.35-.65c-.23-.39-.27-.26-.45-.58"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M11.66,110c-.11-.34-.14-.34-.25-.67s-.12-.34-.24-.68,0-.37-.13-.71-.07-.35-.19-.69-.06-.36-.17-.7-.06-.36-.18-.7-.13-.33-.25-.67-.32-.27-.43-.61-.06-.36-.17-.69,0-.39-.08-.73-.16-.32-.28-.66-.24-.3-.36-.64.07-.4,0-.74-.32-.27-.44-.61,0-.39-.07-.73-.26-.29-.37-.63-.07-.36-.18-.7,0-.37-.13-.71-.11-.35-.23-.69-.21-.3-.33-.65,0-.39-.08-.73S7,95.3,6.85,95s-.22-.3-.34-.65-.18-.32-.29-.66.08-.41,0-.75-.11-.35-.22-.69-.28-.29-.4-.63"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M3.45,73.3c0-.35.1-.35.11-.7l0-.71c0-.35-.06-.36,0-.71s0-.35,0-.71.1-.34.12-.69-.09-.36-.07-.71,0-.36,0-.71,0-.35,0-.71.11-.35.13-.7,0-.35.07-.71.06-.35.08-.7.07-.35.09-.71,0-.35,0-.71-.17-.36-.15-.72.06-.35.08-.7.16-.35.17-.71,0-.36,0-.71-.1-.36-.08-.72.18-.34.2-.7-.18-.36-.16-.72.16-.35.18-.71-.12-.36-.1-.72.06-.35.07-.71"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M6.24,40.53c.14-.32.06-.22.27-.66.08-.17.34-.31.46-.56s.14-.43.26-.66.11-.45.23-.67.26-.38.38-.6l.32-.63c.11-.2.16-.44.27-.65s.26-.39.38-.61.29-.36.41-.58l.34-.62c.11-.2.16-.44.28-.65s.24-.41.36-.62.31-.36.43-.57.13-.46.25-.66.21-.42.33-.63l.35-.61c.11-.21.32-.36.44-.57s.26-.39.39-.59.28-.38.4-.59.29-.38.41-.58.22-.42.34-.62.07-.51.19-.71.29-.38.42-.59.36-.33.49-.53.2-.43.33-.63.13-.48.26-.68.39-.31.52-.52.07-.52.2-.73"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M25.47,13.86c.3-.22.29-.06.67-.33.17-.12.35-.28.58-.44l.59-.43c.19-.13.43-.22.64-.36s.3-.41.51-.55.43-.22.64-.36.36-.33.56-.47.38-.3.58-.44.49-.15.69-.29.37-.32.57-.46.36-.34.56-.48.44-.22.65-.36l.61-.4c.21-.13.38-.32.59-.45s.43-.23.64-.36.46-.2.66-.32L35.85,7c.22-.13.4-.31.61-.42l.65-.33c.25-.11.5-.14.7-.22s.41-.26.61-.34.44-.2.64-.28l.63-.25C40,5,40.2,5,40.36,5c.64-.25.3-.22.64-.22"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M55.5,3.74a5.17,5.17,0,0,1,.71-.06c.2,0,.44.08.71.09s.46-.18.72-.18.46,0,.71,0,.46.07.71.08.47,0,.71,0,.47,0,.72,0,.46.21.7.22.48-.25.72-.24.46.21.7.22h.72l.71,0c.24,0,.47.14.71.16s.49-.19.73-.18.46.15.7.17.48-.06.72,0,.47,0,.71,0,.45.26.69.28.49,0,.72,0,.49-.08.73-.06.47.14.7.17l.72.08c.24,0,.49,0,.73,0s.47.12.7.15.46.18.7.21L74,5c.24,0,.49,0,.72,0l.71.14c.23,0,.45.21.68.26s.5,0,.73,0l.7.13.7.16"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M89.22,12.14l.64.35.62.37c.2.11.38.27.61.41s.4.26.62.39.51.08.73.21l.63.37c.2.13.29.45.5.58s.43.23.64.36.44.22.65.35.38.31.59.44.47.15.68.28l.62.39c.2.13.38.3.58.44l.62.39c.2.14.41.25.61.39s.33.39.53.53.51.12.71.26.32.39.52.54l.61.41.59.44c.2.15.35.36.54.51s.49.17.68.32.34.36.53.51.43.26.62.42.4.29.59.45.27.43.45.59.42.28.6.44"
              style="fill: none"
            />
            <path
              class="heartpath"
              d="M110.45,37.63c.16.32.24.16.45.56.08.18.1.44.22.68s.3.36.41.59.15.43.26.66.14.44.25.66.32.36.42.58.12.46.22.68.24.41.33.63,0,.49.15.71.31.37.41.59.19.43.28.65.14.45.23.67.25.4.34.62,0,.49.12.71.28.4.37.62.12.46.2.68.2.43.29.65.06.49.14.71.21.43.29.65.2.43.28.66.26.41.33.64-.07.52,0,.74.22.43.29.65,0,.49.08.71.2.44.25.67.08.46.13.69"
              style="fill: none"
            />
            <!-- <text x="50" y="115" class="small" style="color:">Just Start Drawing</text> -->
          </svg>
          <div class="lgtext hidden lg:block">Start Drawing</div>
          <div class="smtext lg:hidden">Tap to draw.</div>
          <!-- <div>Start Drawing</div> -->
        </div>
      </transition>
      <div
        id="toolbox"
        class=" bg-white flex justify items-center border-t border-t-red-100"
      >
      <transition name="fade">

          <ColourWheel
            v-model="selectedColour"
            @selectColour="selectColour"
            :value="selectedColour"
            :showUi="showUi"
            class="my-1"
            @isOpen="toolboxState"
            ref="wheel"
          />
        
       
        </transition>

<transition name="fade">
        <div
          id="weight"
          class="right-0 bottom-0 px-2 border-l-red-100 border-l border-l-solid h-20 pt-1"
        >
          
          <BrushSize
            id="brushsize"
            v-model="weight"
            :color="selectedColour"
            class="z-10 h-full "
          />
        </div>
        </transition>
        </div>
      </div>
      <div>
      <div
        id="buttons"
        class="relative flex-1 flex mb--8 h-16 justify-center items-center bg-white border-t border-t-red-100"
      >
        
        <Button
          id="submit"
          class=" text-red-100 h-12 border-red-100 border-2 border-solid flex-grow mx-2 my-4 float-right items-center justify-center hover:text-red-100"
          @click="openSubmitModal"
        >
          <span>Submit</span></Button
        >
      </div>
      </div>
    </div>
    <SubmitModal
      :name="name"
      :email="email"
      :anon="anon"
      :thumb="heartsrc"
      v-show="showSubmitModal"
      @close="showSubmitModal = false"
    />
  </section>
</template>

<script>
import ColourWheel from "@/components/ColourWheel.vue";
// import { Tweenlite, TimelineMax } from "gsap/all";
import Sketch from "sketch-js";
import Button from "@/components/Button.vue";
import BrushSize from "@/components/BrushSize.vue";
import SubmitModal from "@/components/SubmitModal.vue";
import Swatch from "@/components/Swatch.vue";
import { gsap } from "gsap/all";
import DrawSVGPlugin from "gsap/DrawSVGPlugin.js";


gsap.registerPlugin(DrawSVGPlugin);

export default {
  components: {
    Button,
    ColourWheel,
    BrushSize,
    SubmitModal,
    // Swatch,
  },
  props: [
    // "weight"
    // "isTouch"
  ],
  name: "Draw",
  data: function() {
    return {
      isTouch:"",
      ie11:null,
      showInstructions: false,
      mobileFreeze:false,
      canvasInitiated: false,
      showWheel:false,
      // colorPickerOpen:false,
      weight: 3,
      selectedColour: "#ff3c39",
      class: "rounded-md",
      COLOURS: ["#ff3c39", "#fcdeda", "#19324F", "#e3e3e3", "eraser"],
      rasterHistory: [],
      showSubmitModal: false,
      name: "",
      showUi:true,
      email: "",
      anon: false,
      heartsrc: "",
      swatches: [
        "#ff3c39"
      ],
      toolboxOpen: false,
    };
  },
  computed: {

    canShowApp(){
      return window.innerHeight>500;
    }

  },
  mounted() {
    //eslint-disable-next-line
    this.ie11 = navigator.userAgent.match(/Trident.*rv\:11\./);
    // this.isTouch = this.is_touch_device();
    // alert(this.isTouch);
    window.addEventListener("resize", this.handleResize);
    var paths = document.querySelectorAll("#heart path");
    let $this = this;

    var tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });
    tl.fromTo(
      ".heartpath",
      1,
      { drawSVG: "0%" },
      { duration: 0.175, drawSVG: "100%", stagger: 0.075 },
      "0"
    ).fromTo(
      ".heartpath",
      1,
      { drawSVG: "100%" },
      {
        duration: 0.175,
        drawSVG: "100% 100%",
        stagger: 0.075,
        reverse: true,
      },
      "3.5"
    );

    this.sketch = Sketch.create({
      COLOURS: [
        "#ff3c39",
        "#fcdeda",
        "#19324F",
        "#e3e3e3",
        "#ffffff",
        "eraser",
      ],
      container: document.getElementById("surface"),
      autoclear: false,
      retina: true,
      fullscreen: false,

      width: document.getElementById("drawcolumn").offsetWidth,
      height: document.getElementById("drawcolumn").offsetWidth,

      interval: 1,
      strokes: [],
      rasterHistory: [],
      animateIds: [],
      colors: [],
      weight: "3",
      currentColour: 0,
      maxLineThickness: 50,
      minLineThickness: 1,
      // eslint-disable-next-line
      lineThicknessRange: 40, //this.maxLineThickness - +this.minLineThickness,
      thicknessIncrement: 0.5,
      minSmoothingFactor: 0.9,
      initialSmoothingFactor: 0.95,
      weightSpread: 6,
      initialThickness: 3,
      smoothing: 10,
      currentStroke: { segments: [] },
      sketch: null,
      lastWidth: document.getElementById("drawcolumn").offsetWidth,
      selectedColour: "#ff3c39",
      prevH: document.getElementById("surface").offsetWidth,
      prevW: document.getElementById("surface").offsetWidth,

      resize: function() {
        // this.handleResize();
      },

      setWeight: function(w) {
        this.weight = w;
        this._weight = w;
        this._thickness = w;
        this._targetThickness = w;
        this._maxWeight = +w + +this.weightSpread;
      },
      calcDistance: function(x1, y1, x2, y2) {
        var xs = Math.pow(x2 - x1, 2);
        var ys = Math.pow(y2 - y1, 2);
        return Math.sqrt(xs + ys);
      },
      calcV: function(dx, dy) {
        return Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
      },

      rasterize: function() {
        return this.canvas.toDataURL();
      },

      resetStroke: function() {
        this.currentStroke = {
          segments: [],
        };
      },

      recordStroke: function() {
        this.strokes.push(this.currentStroke);
        localStorage.heart = this.canvas.toDataURL();
      },

      recordRasterStroke: function() {
        if (this.rasterHistory.length == 50) {
          this.rasterHistory.unshift();
        }

        this.rasterHistory.push(this.canvas.toDataURL());
        $this.rasterHistory = this.rasterHistory;
      },

      drawStroke: function(stroke) {
        this.lineCap = "round";
        this.lineJoin = "round";

        this.globalCompositeOperation = stroke.mode;

        this.strokeStyle = this.fillStyle = stroke.c;
        this.globalCompositeOperation = stroke.mode;
        this.lineWidth = this._weight = this.weight = this._thickness = eval(
          stroke.w
        );

        this.beginPath();
        for (var j = 0; j < stroke.segments.length; j++) {
          var segment = stroke.segments[j];
          this.drawQuadCurve(segment);
        }
      },

      // redraw: function() {
      //   for (var i = 0; i < this.strokes.length; i++) {
      //     this.drawStroke(this.strokes[i]);
      //   }
      // },

      redraw: function(scale) {
        // Resizing the canvas will clear all drawings off the canvas
        // Resizing will also automatically clear the context
        // of all its current values and set default context values
        this.canvas.width = originalWidth * scale;
        this.canvas.height = originalHeight * scale;

        // context.scale will scale the original drawings to fit on
        // the newly resized canvas
        ctx.scale(scale, scale);

        draw(ctx);

        // always clean up! Reverse the scale
        ctx.scale(-scale, -scale);
      },

      // var scale=parseInt($(this).val())/100;
      // scale1=scale;
      // redraw(ctx1,scale);

      // TODO : Implement pixel sampling
      // TODO: Revisit line smoothing
      calcSegment: function(oseg) {
        var seg = Object.assign({}, oseg);

        var x = seg.x;
        var y = seg.y;
        var prevX = seg.ox;
        var prevY = seg.oy;

        var rawDist = this.calcV(seg.dx, seg.dy);

        var smoothingFactor = Math.min(
          this.minSmoothingFactor,
          this.smoothing + +(rawDist - 60) / 3000 // ?? what are 60 / 3000
        );

        var newseg = Object.assign({}, seg);

        newseg.x = x - (x - prevX) * smoothingFactor;
        newseg.y = y - (y - prevY) * smoothingFactor;
        y;

        var dist = Math.sqrt(Math.pow(seg.dx, 2) + Math.pow(seg.dy, 2));
        var _targetThickness =
          ((dist - this.minLineThickness) / this.lineThicknessRange) *
            this.weightSpread +
          +seg.w;

        if (this._thickness > _targetThickness) {
          this._thickness -= this.thicknessIncrement;
        } else if (this._thickness < _targetThickness) {
          this._thickness += +_targetThickness;
        }

        newseg.w = this.lineWidth = Math.min(
          +this._thickness,
          seg.w + +this.weightSpread
        );

        return newseg;
      },

      drawQuadCurve(seg) {
        this.lineWidth = seg.w;
        this.quadraticCurveTo(seg.ox, seg.oy, seg.x, seg.y);
        this.stroke();
        // delete seg;
      },

      reset: function() {
        this.clear();
        this.fillStyle = "#FFFFFF";
        this.fillRect(0, 0, this.width, this.height);
        this.recordRasterStroke();
      },

      undo: function() {
        this.strokes.pop();
        this.clear();
        // this.redraw();
      },

      redo: function(){
        this.rasterHistory.push( this.rasterFuture.pop() );
      },

      altUndo() {
        if (this.rasterHistory.length > 0) {
          var img = new Image();
          this.rasterHistory.pop();
          img.src = this.rasterHistory[this.rasterHistory.length - 1];
          var $ctx = this;
          img.onload = function() {
            this.clear();
            this.drawImage(img, 0, 0, $ctx.width, $ctx.height);
          }.bind(this);
        }
      },

      initStroke: function() {
        this.lineCap = "round";
        this.lineJoin = "round";

        this.strokeStyle = $this.selectedColour;
        this.globalCompositeOperation = this.currentStroke.mode =
          $this.selectedColour == "eraser" ? "destination-out" : "source-over";

        this.currentStroke.c = this.strokeStyle;
        this.currentStroke.lineWidth = this.currentStroke.w = this.lineWidth = this._weight = this.weight;
        this.beginPath();
      },

      serialize: function() {
        return JSON.stringify(this.strokes);
      },

      touchstart: function() {
        this.resetStroke();
        this.setWeight($this.weight);
        this.initStroke();
        this.isDrawing = true;
        $this.showUi = false;

      },

      touchend: function() {
        this.recordRasterStroke();
        this.isDrawing = false;
        $this.showUi = true;
      },

      update: function() {
   
      },

      mouseout: function() {
        this.isDrawing = false;
      },

      dragout: function(){
        this.isDrawing = false;
      },

      touchmove: function() {
        var touch = this.touches[0];

        if (this.isDrawing == true) {
          touch.w = +this._weight;
          touch = this.calcSegment(touch);
          this.currentStroke.segments.push(Object.assign({}, touch));
          this.drawQuadCurve(Object.assign({}, touch));
          if (touch.x > 800) {
            this.isDrawing = true;
          }
        }
      },
    });

    this.sketch.reset();

    if (localStorage.heart) {
      this.canvasInitiated = true;
      var storedHeart = new Image();
      storedHeart.src = localStorage.heart;
      this.sketch.drawImage(
        storedHeart,
        0,
        0,
        this.sketch.width,
        this.sketch.height
      );
      this.handleResize();
    }
  },
  watch:{
    showUi(newVal,oldVal){
      if (newVal==false) {
        this.$refs.wheel.isOpen = false;
      }
    }
  },
  methods: {
    cancelDrawing(){
      this.canvasInitiated = false;
      this.sketch.reset();
    },
         is_touch_device() {
    if ("ontouchstart" in window || window.TouchEvent)
        return true;

    if (window.DocumentTouch && document instanceof DocumentTouch)
        return true;

    const prefixes = ["", "-webkit-", "-moz-", "-o-", "-ms-"];
    const queries = prefixes.map(prefix => `(${prefix}touch-enabled)`);

    return window.matchMedia(queries.join(",")).matches;
},
    
    toggleInstructions() {
      this.showInstructions = !this.showInstructions;
    },
    toolboxState(v) {
      this.toolboxOpen = v;
    },
    handleResize: function(e) {
      let cv = document.querySelector("#surface > canvas");
      var ctx = this.sketch;

      ctx.canvas.width = document.getElementById("surface").offsetWidth;
      ctx.canvas.height = document.getElementById("surface").offsetWidth;

      ctx.width = document.getElementById("surface").offsetWidth;
      ctx.height = document.getElementById("surface").offsetWidth;

      if (this.rasterHistory.length > 0) {
        var lastimage = new Image();
        lastimage.src = this.rasterHistory[this.rasterHistory.length - 1];
        lastimage.onload = function() {
          ctx.drawImage(lastimage, 0, 0, ctx.width, ctx.height);
        }.bind(ctx, lastimage);
      }
    },
    isBlank() {
      // console.log('blank');
      if (
        this.sketch == "" ||
        this.sketch == null ||
        this.sketch == undefined
      ) {
        return true;
      }

      var pixelBuffer = new Uint32Array(
        this.sketch.getImageData(
          0,
          0,
          this.sketch.width,
          this.sketch.height
        ).data.buffer
      );
      // console.log("buffer",pixelBuffer);
      if (pixelBuffer.some((color) => color !== 0 && color != 4294967295)) {
        return false;
      } else {
        return true;
      }
    },
    openSubmitModal() {
      if (this.isBlank() == true) {
        //TODO: Show Blank Message
        alert("Can't submit a blank canvas. Draw something first.");
      } else {
        this.heartsrc = this.sketch.rasterize();
        this.showSubmitModal = true;
      }
    },
    addWatermark() {
      var tempCanvas = document.createElement("CANVAS");
      tempCanvas.width = this.sketch.canvas.width;
      tempCanvas.height = this.sketch.canvas.height * 1.1875;

      var ctx = tempCanvas.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

      ctx.fillStyle = "#ffd4ce";
      ctx.fillRect(
        0,
        this.sketch.canvas.height,
        tempCanvas.width,
        tempCanvas.height
      );

      ctx.font = "42px relative-book-pro";
      ctx.fillStyle = "#FF3C39";
      ctx.fillText(
        "Sent with Love by ______ ______",
        58,
        this.sketch.canvas.height + 100 + 42
      );
      ctx.fillText(
        "See more at caseyhouse.com/love",
        58,
        this.sketch.canvas.height + 154 + 42
      );

      ctx.drawImage(this.sketch.canvas, 0, 0);

      var logo = document.getElementById("headerlogo");
      logo.width = 166;
      logo.height = 153;
      ctx.drawImage(
        logo,
        this.sketch.canvas.height - 194,
        this.sketch.canvas.height + 100
      );

      return ctx.canvas.toDataURL();
    },
    // stopDrawing(e) {
    //   this.sketch.isDrawing = false;
    //   this.sketch.recordRasterStroke();
    // },
    // isWithinBounds(e) {
    // var ctx = document.querySelector("#surface > canvas");
    // var e =
    // var rect = document.querySelector("#surface > canvas").getBoundingClientRect();

    // if (
    //   e.clientX > rect.right ||
    //   e.clientX < rect.left ||
    //   e.clientY < rect.top ||
    //   e.clientY > rect.bottom
    // ) {
    //   this.sketch.isDrawing = false;
    //   this.recordRasterStroke();
    // }
    // },
    selectColour(c) {
      this.selectedColour = c;
    },

    downloadRaster: function() {
      var rasterized = this.addWatermark();
      var img = document.createElement("img");
      img.src = rasterized;

      var download = document.createElement("a");
      download.href = rasterized;
      download.download = "SendYourLove.png";
      download.click();
    },
    submitHeart: function() {},
    canvasReset: function() {
      this.sketch.reset();
    },
    canvasUndo: function() {
      // this.sketch.undo();
      this.sketch.altUndo();
    },

    recordColour: function(clr) {
      var colorUsed = this.colorHistory.find((el) => el == this.selectedColour);

      if (!colorUsed) {
        if (this.colorHistory.length >= 8) {
          this.colorHistory.pop();
        }
        this.colorHistory.unshift(this.selectedColour);
      }
    },
  },
};
</script>

<style>


.circle1 {
  width: 2px;
  height: 2px;
}

svg#heart {
  width: 25%;
  height: 25%;
  pointer-events: none;
}

.circle50 {
  width: 50px;
  height: 50px;
}

.verte__inputs,
.verte__close {
  display: none !important;
}

strong {
  font-weight: normal;
}

#surface > canvas {
  background-color: white;
  cursor: crosshair;
  z-index: 0;
  position: relative;
}

svg#heart path {
  stroke-width: 6;
  stroke-linecap: round;
  stroke: #19324f;
  /* animation: drawstroke1 2s linear forwards; */
  /* stroke-dasharray: 100;
  stroke-dashoffset: 100; */
}

.uibtn{
  background: rgba(255,255,255,.95);
}

svg#heart text {
  /* color: #19324f; */
}

.in-viewport path {
  /* animation: drawstroke1 2s ease-in forwards; */
}

#container.down .in-viewport.above-viewport path {
  /* animation: undraw 2s ease-in-out forwards; */
}

.lgtext,
.smtext {
  color: #19324f;
}

input[type="range"][orient="vertical"] {
  writing-mode: bt-lr; /* IE */
  -webkit-appearance: slider-vertical; /* WebKit */
  width: 8px;
  height: 100px;
  padding: 0 5px;
}

#clear,#cancel {
  position: absolute;
  top: .5rem;
  left: .5rem;
  z-index: 10;
}

#cancel{
  /* margin-top: -2rem; */
}

#undo {
  position: absolute;
  top: .5rem;
  right: .5rem;
  z-index: 10;
}

#redo{
  position: absolute;
  top: 1rem;
  right:1rem;
}

.actions {
  text-align: right;
}

button {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
}

button:hover {
  color: red;
}

a {
  cursor: pointer;
}

#replay {
  float: left;
  clear: none;
}

#instructions p {
  margin-bottom: 1em;
}

.toollabel {
  font-size: 0.7rem;
}

#brushsize {
 
}

#eraser {
  background-image: url("~@/assets/img/checkers.png");
  background: size 50%;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.m2{
  margin:2px;
}

#drawColumn .appMode *{


  touch-action: manipulation !important


}

#drawcolumn.appMode > #buttons{
  position: relative !important;
  margin-top:0 !important;
}

#colorstrip{
  width:calc(100% - 6rem);
}



@media only screen and ( max-width: 768px ) {

.appMode{
  position: fixed !important;
  top:0 !important;
  left:0 !important;
  right:0 !important;
  bottom:0 !important;
  height:100vh!important;
  width:100vw !important;
  z-index:500 !important;
  background-color: #ffffff !important;
}

  #drawcolumn:not(.appMode) #buttons,
  #drawcolumn:not(.appMode) #toolbox{
    display: none !important;
  }

  #drawcolumn:not(.appMode) #surface, #drawcolumn:not(.appMode) #drawaheartoverlay {
    transform: scale(.8,.8);
    border-radius:1rem;
  }

  #drawcolumn:not(.appMode) canvas.sketch{
  border-radius:.5rem;
}


}



</style>
